export default "__VITE_ASSET__511319c2__"